import "$styles/index.css"
import "$styles/syntax-highlighting.css"
import {
  ArrowRight,
  BarChart3,
  CalendarDays,
  CheckCircle2,
  CircleHelp,
  ExternalLink,
  FileText,
  Inbox,
  Link as LinkIcon,
  LockKeyhole,
  Megaphone,
  MessageSquareText,
  Newspaper,
  BriefcaseBusiness,
  Settings,
  ShieldCheck,
  Upload,
  UsersRound,
  createIcons,
} from "lucide"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

createIcons({
  icons: {
    ArrowRight,
    BarChart3,
    CalendarDays,
    CheckCircle2,
    CircleHelp,
    ExternalLink,
    FileText,
    Inbox,
    Link: LinkIcon,
    LockKeyhole,
    Megaphone,
    MessageSquareText,
    Newspaper,
    BriefcaseBusiness,
    Settings,
    ShieldCheck,
    Upload,
    UsersRound,
  },
})
